import { ChangeDetectionStrategy, Component, DestroyRef, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { ActivatedRoute } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { SettingsService } from "../../shared/services/settings.service";

@Component({
  selector: "new-ui-login",
  template: "",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewUiLoginComponent implements OnInit {
  constructor(
    private readonly settings: SettingsService,
    private readonly auth: AuthService,
    private readonly route: ActivatedRoute,
    private readonly destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.settings.isAuthenticated$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((isAuthenticated) => {
      if (!isAuthenticated) {
        this.auth.loginWithRedirect({
          appState: { target: this.route.snapshot.queryParams.target ?? undefined },
          authorizationParams: { login_hint: this.route.snapshot.queryParams.email ?? undefined },
        });
      } else {
        this.settings.navigateToMain();
      }
    });
  }
}
